import { render, staticRenderFns } from "./IdentificacaoAmplaCota.vue?vue&type=template&id=06d84180&scoped=true"
import script from "./IdentificacaoAmplaCota.vue?vue&type=script&lang=js"
export * from "./IdentificacaoAmplaCota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d84180",
  null
  
)

export default component.exports